<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" pageId="timeoff-page" color="white"></help-link>
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this timesheet.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this timesheet.">Closed</v-chip>
                    <v-btn v-if="hasAddRights" title="Add Personal Time Off" @click="showPTO" class="primary" v-show="!disableConditions">
                        <v-icon>add</v-icon>Add&nbsp;
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-alert v-if="approved_timereport" :value="true" color="warning" icon="warning" outline style="margin:10px 0px 10px 0px;">
                The timesheet for this period has already been approved.
            </v-alert>
            <v-card v-if="!loading" class="elavation-1 mt-10"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold">Timeoff Requests</span>
                    <v-spacer></v-spacer>
                    <span class="font-weight-bold">{{cutOffPeriod}}</span>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile?headers_mobile:headers"
                    :items="timeoffs"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >                    
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" style="cursor:pointer;" title="Click to view timesheet for this period">
                            <td>
                                <span v-if="isMobile">{{ props.item.transDate | moment("MMM DD") }}</span>
                                <span v-else>{{ props.item.transDate | moment("YYYY-MM-DD") }}</span>
                            </td>
                            <td>{{ props.item.leaveName }}</td>
                            <td>{{ props.item.hours }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                            <td v-if="!isMobile">{{ props.item.remarks }}</td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>
        <v-dialog v-model="dialogPTO" width="600" persistent>   
            <pto-component ref="ptoComponentRef" @send="getTimeoffs(false)" :dialogPTO.sync="dialogPTO"></pto-component>
        </v-dialog>
    </v-layout>  
</template>

<script>

import timeoffApi from '@/api/timeoffs'
import commonfn from '@/common/functions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import { hasAddRights } from '@/helpers/access-permissions'

export default {     
    name: 'MyTimeOff',
    metaInfo: {
        title: 'My Time Off',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Time Off' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'pto-component': () => import('@/components/Attendance/TimeOff2'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            error: false,
            errorMessage: '',
            loading: false,
            loading_download: false,
            serverDate: null,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Leave Type',align: 'left',value: 'leaveName', width:'10%',sortable:true},
                {text: 'Hours',align: 'left',value: 'hours', width:'10%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'10%',sortable:true},
                {text: 'Remarks',align: 'left',value: 'chargeableHours', width:'10%',sortable:false}, 
            ],
            headers_mobile: [
                {text: 'Date',align: 'left',value: 'transDate', width:'20%', sortable:true},
                {text: 'Type',align: 'left',value: 'leaveName', width:'55%',sortable:true},
                {text: 'Hours',align: 'left',value: 'hours', width:'5%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'20%',sortable:true},
            ],
            cutoff_details: null,
            timeoffs: [],
            dialogPTO: false,
            workShifts: null,
            timeReport: null
        }
    },
    methods: {  
        showPTO() {
            var data = {
                mode: 'Add',
                cutoff: this.cutoff_details,
                workShift: ''
                // workShift: `${this.workShifts.name} (${this.$moment(this.workShifts.clockStart).format('h:mm a')} - ${this.$moment(this.workShifts.clockEnd).format('h:mm a')})`,
                
            }
            this.$refs.ptoComponentRef.setParams(data)
            this.dialogPTO = true
        },
        async downloadToExcel() {
        },
        viewDetails(data) {
            this.$router.push(`details/${data.timeOffId}`)
        }, 
        async getTimeoffs(show_loading) {
            try {
                this.loading = show_loading
                const response = await timeoffApi.getByCutoffByUser(this.selectedCutOffId)
                if (response && response.status == 200) {
                    this.cutoff_details = response.data.cutoffItem
                    this.timeoffs = response.data.items
                    // this.workShifts = response.data.workShift
                    this.timeReport = response.data.timeReport
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'My Time Off',
            headerPageTitle: ''
        })

        this.getTimeoffs(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        cutOffPeriod() {
            if (this.cutoff_details) {
                if (this.isMobile)
                    return `${this.$moment(this.cutoff_details.cutoffStart).format('MMM DD')} to ${this.$moment(this.cutoff_details.cutoffEnd).format('DD, YYYY')}`
                else
                    return `${this.$moment(this.cutoff_details.cutoffStart).format('MMM DD, YYYY')} to ${this.$moment(this.cutoff_details.cutoffEnd).format('MMM DD, YYYY')}`
            }  
        },
        frozenPeriod() {
            if (this.cutoff_details) 
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod() {
            if (this.cutoff_details) 
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
        },
        approved_timereport() {
            if (this.timeReport!=null)
                return this.timeReport.status==commonfn.getStatusCode('Approved')
        },
        disableConditions() {
            return (this.loading||
                    this.frozenPeriod || 
                    this.closedPeriod ||
                    this.approved_timereport
                    )  
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>